import * as FileUploadTypes from 'web-app/react/components/file-upload/types';

export const TAGGABLE_MEDIA_TYPES = [FileUploadTypes.MediaType.Image, FileUploadTypes.MediaType.Video];
